/*!
 * FrontAlign v1.0.9
 * (c) Eyruz Badalzada
 * Released under the MIT License
 * https://www.frontalign.dev
 */

import { useEffect, useRef, useCallback } from "react";
import DarkMode from "../js/components/DarkMode.js";

/**
 * Provides helpers for creating dark mode components.
 */
export function useDarkMode(options = {}) {
  const instanceRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }

    const { onChange, ...darkModeOptions } = options;

    const instance = new DarkMode(darkModeOptions);

    if (typeof onChange === "function") {
      instance.onChange(onChange);
    }

    instanceRef.current = instance;

    return () => {
      instanceRef.current?.dispose();
      instanceRef.current = null;
    };
  }, []);

  const isDark = useCallback(() => {
    return instanceRef.current?.isDark() ?? false;
  }, []);

  return { isDark };
}
